var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (
		(_vm.initialDecisionItems.length > 0 && _vm.matrixButtons.length > 0) ||
		_vm.displayData
	)?_c('div',{attrs:{"id":"set-decision-matrix"}},[_c('initialDecision',{attrs:{"isModifiable":true}}),_c('decisionMatrix',{attrs:{"onMatrixClick":_vm.onMatrixClick}})],1):_c('div',[_c('v-skeleton-loader',{attrs:{"type":"article"}}),_c('v-skeleton-loader',{attrs:{"type":"article"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }